"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Retry = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M7.354 4.646a.5.5 0 000 .708l3.792 3.792A.5.5 0 0012 8.793V6a6 6 0 11-5.98 6.5.534.534 0 00-.52-.5h-1a.477.477 0 00-.485.5A8 8 0 0012 20c2.152 0 4.105-.85 5.543-2.232A7.963 7.963 0 0020 12a8 8 0 00-7.5-7.985h-.008A8.123 8.123 0 0012 4V1.207a.5.5 0 00-.854-.353L7.354 4.646z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Retry;
